import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';
import {getStorage} from 'firebase/storage';

const firebaseConfig = {
  "apiKey": "AIzaSyBy9ANY6BkytPoPnlUQfgQR0bYjh2Mxa_Q",
  "authDomain": "terrasciences-website.firebaseapp.com",
  "projectId": "terrasciences-website",
  "storageBucket": "terrasciences-website.firebasestorage.app",
  "messagingSenderId": "449454349862",
  "appId": "1:449454349862:web:40c1ad6937437905c450e7"
}

const firebaseApp = initializeApp(firebaseConfig);

export const auth = getAuth(firebaseApp);
export const storage = getStorage(firebaseApp);
export default firebaseApp;